import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import {
  Search,
  Shield,
  Laptop,
  Smartphone,
  Calendar,
  DollarSign,
} from "lucide-react";
import { useState } from "react";
function ProtectionPlans() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const protectionPlans = [
    {
      id: 1,
      planId: "CP-2024-789456",
      customerName: "John Doe",
      customerEmail: "john.doe@email.com",
      productName: 'MacBook Pro 16" (2023)',
      productType: "laptop",
      coverageType: "extended",
      purchaseDate: "2024-01-15",
      expirationDate: "2025-12-15",
      purchasePrice: "2499.00",
      status: "active",
      claimsCount: 1,
    },
    {
      id: 2,
      planId: "CP-2024-567890",
      customerName: "John Doe",
      customerEmail: "john.doe@email.com",
      productName: "iPhone 15 Pro",
      productType: "phone",
      coverageType: "basic",
      purchaseDate: "2024-03-10",
      expirationDate: "2025-03-10",
      purchasePrice: "999.00",
      status: "active",
      claimsCount: 1,
    },
    {
      id: 3,
      planId: "CP-2024-123789",
      customerName: "Sarah Wilson",
      customerEmail: "sarah.wilson@email.com",
      productName: "Dell XPS 13",
      productType: "laptop",
      coverageType: "basic",
      purchaseDate: "2024-02-20",
      expirationDate: "2025-02-20",
      purchasePrice: "1299.00",
      status: "active",
      claimsCount: 0,
    },
    {
      id: 4,
      planId: "CP-2023-987654",
      customerName: "Michael Chen",
      customerEmail: "michael.chen@email.com",
      productName: 'iPad Pro 12.9"',
      productType: "tablet",
      coverageType: "extended",
      purchaseDate: "2023-11-15",
      expirationDate: "2024-11-15",
      purchasePrice: "1199.00",
      status: "expired",
      claimsCount: 2,
    },
  ];

  const filteredPlans = protectionPlans.filter((plan) => {
    const matchesStatus =
      statusFilter === "all" || plan.status === statusFilter;
    const matchesSearch =
      plan.planId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      plan.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      plan.productName.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  const getStatusBadge = (status) => {
    return status === "active" ? (
      <Badge className="bg-success text-white">Active</Badge>
    ) : status === "expired" ? (
      <Badge className="bg-error text-white">Expired</Badge>
    ) : (
      <Badge className="bg-warning text-white">Suspended</Badge>
    );
  };

  const getProductIcon = (productType) => {
    switch (productType) {
      case "laptop":
        return <Laptop className="text-comerco-primary" size={16} />;
      case "phone":
        return <Smartphone className="text-comerco-primary" size={16} />;
      default:
        return <Shield className="text-comerco-primary" size={16} />;
    }
  };

  const getCoverageColor = (coverageType) => {
    return coverageType === "extended" ? "text-success" : "text-info";
  };
  return (
    <>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Protection Plans
          </h1>
          <p className="text-slate-600">
            Manage and monitor all active protection plans
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Total Plans
                  </p>
                  <p className="text-3xl font-bold text-slate-900">3,456</p>
                </div>
                <div className="w-12 h-12 bg-comerco-primary bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Shield className="text-comerco-primary" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Active Plans
                  </p>
                  <p className="text-3xl font-bold text-slate-900">3,201</p>
                </div>
                <div className="w-12 h-12 bg-success bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Shield className="text-success" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Expiring Soon
                  </p>
                  <p className="text-3xl font-bold text-slate-900">89</p>
                </div>
                <div className="w-12 h-12 bg-warning bg-opacity-10 rounded-lg flex items-center justify-center">
                  <Calendar className="text-warning" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="!p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">
                    Revenue This Month
                  </p>
                  <p className="text-3xl font-bold text-slate-900">$45.2K</p>
                </div>
                <div className="w-12 h-12 bg-info bg-opacity-10 rounded-lg flex items-center justify-center">
                  <DollarSign className="text-info" size={24} />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Search & Filters */}
        <Card>
          <CardContent className="!p-6">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1 relative">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                  size={16}
                />
                <Input
                  placeholder="Search by plan ID, customer, or product..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="flex gap-3">
                <Select value={statusFilter} onValueChange={setStatusFilter}>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder="All Statuses" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Statuses</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="expired">Expired</SelectItem>
                    <SelectItem value="suspended">Suspended</SelectItem>
                  </SelectContent>
                </Select>
                <Button className="bg-comerco-primary hover:bg-blue-700">
                  Export Plans
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Plans Table */}
        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead>Plan Details</TableHead>
                  <TableHead>Customer</TableHead>
                  <TableHead>Product</TableHead>
                  <TableHead>Coverage</TableHead>
                  <TableHead>Purchase Price</TableHead>
                  <TableHead>Purchase Date</TableHead>
                  <TableHead>Expiration</TableHead>
                  <TableHead>Claims</TableHead>
                  <TableHead>Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredPlans.map((plan) => (
                  <TableRow
                    key={plan.id}
                    className="hover:bg-slate-50 cursor-pointer"
                  >
                    <TableCell>
                      <div>
                        <p className="font-mono text-sm font-medium">
                          {plan.planId}
                        </p>
                        <p className="text-xs text-slate-500">
                          ID: {plan.id.toString().padStart(6, "0")}
                        </p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div>
                        <p className="font-medium text-slate-900">
                          {plan.customerName}
                        </p>
                        <p className="text-sm text-slate-500">
                          {plan.customerEmail}
                        </p>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        {getProductIcon(plan.productType)}
                        <div>
                          <p className="text-sm font-medium">
                            {plan.productName}
                          </p>
                          <p className="text-xs text-slate-500 capitalize">
                            {plan.productType}
                          </p>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span
                        className={`text-sm font-medium capitalize ${getCoverageColor(
                          plan.coverageType
                        )}`}
                      >
                        {plan.coverageType}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span className="font-semibold text-slate-900">
                        ${plan.purchasePrice}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span className="text-sm text-slate-500">
                        {new Date(plan.purchaseDate).toLocaleDateString()}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span className="text-sm text-slate-500">
                        {new Date(plan.expirationDate).toLocaleDateString()}
                      </span>
                    </TableCell>
                    <TableCell>
                      <div className="text-center">
                        <span className="text-lg font-semibold text-slate-900">
                          {plan.claimsCount}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>{getStatusBadge(plan.status)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
export default ProtectionPlans;
